import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActivityModal from './ActivityModal';
import {
  fetchReportNew,
  fetchCommentsFileList,
} from '../../../actions/reportActions';

const SharedActivityModal = ({
  show,
  closeModal,
  activeItem,
  reviewId,
  commentsFileList: propsFileList,
  renderFiles,
  enableCache = true,
}) => {
  const dispatch = useDispatch();
  const { newReport } = useSelector(state => state.report);
  const [loading, setLoading] = useState(true);

  const hasFetchedOnce = useRef(false);

  useEffect(() => {
    if (!show || !reviewId) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        let shouldFetch = true;
        if (enableCache && newReport && newReport.reviewID === reviewId) {
          shouldFetch = false;
        }
        if (shouldFetch && !hasFetchedOnce.current) {
          await dispatch(fetchReportNew({ reviewId }));
          hasFetchedOnce.current = true;
        }
      } catch (error) {
        console.error('Error loading activity modal data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [show, reviewId, dispatch, propsFileList, enableCache]);

  return (
    <ActivityModal
      showActivityModal={show}
      closeModal={closeModal}
      activeItem={activeItem}
      newReport={newReport}
      commentsFileList={propsFileList}
      renderFiles={renderFiles}
      loading={loading}
    />
  );
};
export default SharedActivityModal;
